import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Products } from 'app/_models/products';
import { CrudProductService } from 'app/_services/MasterCrudOps/crud-product.service'
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AddProductsComponent } from './add-products/add-products.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import { UserModel } from 'app/_models/user-model';
import { UiActionUtils } from 'app/shared/utils/ui-action-utils';
declare const swal: any;

@Component({
  selector: 'app-product-master',
  templateUrl: './product-master.component.html'
})
export class ProductMasterComponent implements OnInit, AfterViewInit {
  currentUser: UserModel;
  roles:string[];
  products: Products[] =[];
  displayedColumns: string[] = ["icon", "productName", "description", "edit", "delete"];
  dataSource = new MatTableDataSource<Products>([]);
  @ViewChild(MatPaginator, { static: false }) set paginator(value: MatPaginator) { this.dataSource.paginator = value; }
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) { this.dataSource.sort = value; }
  isLoaderResult :boolean = false;
  isAdminGroupUser :boolean = false;
  resultLength = 0
  editProduct: Products;
  public searchText: string;
  public result: [];

  constructor(
    public datepipe: DatePipe,
    private readonly crudProductService: CrudProductService, 
    private readonly _liveAnnouncer: LiveAnnouncer, 
    private readonly matDialog: MatDialog,
    ) {
      this.currentUser = JSON.parse(sessionStorage.getItem('user'));
      this.roles = this.currentUser.roles;
      this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Products>([]);
    this.getProducts();
    this.crudProductService.Refreshrequired.subscribe(respone=>{
      this.getProducts();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  onAddProduct() {
    this.matDialog.open(AddProductsComponent, {
      width: '800px',
      disableClose: false
    });
    
  }

  updateProduct(e:any, element:any): void {
    this.editProduct = JSON.parse(JSON.stringify(element)) ;//deep copy
     this.matDialog.open(EditProductComponent, {
      width: '800px',
      disableClose: true,
      data: this.editProduct
    });
     
  }

  softDelete1(e, element) {
    swal({
      title: 'Are you sure to delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'YES, Delete IT!'
    }).then((result) => {
      if (result === true) {
        this.deleteProduct(e, element)
      }
    })
  }

    OnDeleteProduct(e, element) {
     UiActionUtils.confirmWithRemarks("You won't be able to revert this!", (remarks: string) => {
    this.deleteProduct(e, element);
  });
  }

  deleteProduct(e, element): void {
    this.isLoaderResult = true;
    this.crudProductService.deleteProduct(element.productId).subscribe(
      data =>
      {
        if (data.didError) {
           UiActionUtils.showError(data.message, data.additionalMessage);
         
        }
        else {
           UiActionUtils.showSuccess(data.message);
        }
      } 
    )
    this.isLoaderResult = false;
  }

  
  getProducts() {
    this.isLoaderResult = true;
    this.crudProductService.getProducts().subscribe(data => {
      this.products = data;
      this.dataSource = new MatTableDataSource<Products>(this.products);
      this.resultLength = this.products.length;     
      this.isLoaderResult = false; 
    });
   
  }

  exportExcel()
  {
    const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data.map((item) => {return { ProductName: item.productName, Description:item.description };}  ));
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
    let fileName ="Products" + this.datepipe.transform(new Date(), 'dd_MM_yyyy_hh_mm')+".xlsx";
    XLSX.writeFile(workBook, fileName);
  }

 applyFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }
  

}
